module.exports = __webpack_public_path__ + "img/f-2-1.0a6aa4cf.png";